import Users from '@/modules/profile/Users'
import { getSubAccountsThunk } from '@/redux/slices/subAccountSlice'
import { getUsageAndBalanceThunk } from '@/redux/slices/usageAndBalanceSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { useEffect } from 'react'

export default function UsersPage() {
  const dispatch = useAppDispatch()
  const subAccountsLoaded = useAppSelector(state => state.subAccounts.loaded)
  const usageAndBalanceLoaded = useAppSelector(state => state.usageAndBalance.loaded)
  const isOwnerOrAdmin = useAppSelector(state => state.currentUser.isOwnerOrAdmin)

  useEffect(() => {
    dispatch(getUsageAndBalanceThunk())
    dispatch(getSubAccountsThunk({ includeInviteLinks: isOwnerOrAdmin }))
  }, [dispatch, isOwnerOrAdmin])

  if (!usageAndBalanceLoaded || !subAccountsLoaded) {
    return null
  }

  return <Users />
}
